import { clientConfig } from '@/config/client';

import { createGetRelativeUrlWithoutRegionLocale } from '.';

const {
    i18n: { locales },
} = clientConfig;

export const getRelativeUrlWithoutRegionLocale = createGetRelativeUrlWithoutRegionLocale(
    locales.map(({ lang }) => lang)
);
